/* Beard & Brawn — Subscribe & Save price sync.
   The selling-plan selector (snippets/bb-selling-plan.liquid) shows a per-delivery
   recurring price that differs per variant. Dawn's product-info.js re-renders the
   section on variant change and publishes PUB_SUB_EVENTS.variantChange with the new
   HTML, but it only swaps a fixed set of ids (#price, #Sku, …) — not our selector.
   So we mirror the fresh price spans ourselves, matching by position (the selector's
   structure is identical across variants). Only the price innerHTML is replaced, so
   the shopper's one-time / subscribe choice is preserved. */
(function () {
  'use strict';

  function syncFrom(html) {
    if (!html || !html.querySelector) return;
    var current = document.querySelector('[data-bb-plan]');
    var incoming = html.querySelector('[data-bb-plan]');
    if (!current || !incoming) return;

    var cur = current.querySelectorAll('.bb-plan__price');
    var inc = incoming.querySelectorAll('.bb-plan__price');
    if (cur.length !== inc.length) return; // structure changed (product swap) — leave server HTML as-is

    for (var i = 0; i < cur.length; i++) {
      cur[i].innerHTML = inc[i].innerHTML;
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      if (evt && evt.data && evt.data.html) syncFrom(evt.data.html);
    });
  }
})();
